import { useSyncExternalStore } from 'react';

import { isShakeReady, subscribeShake } from '@/lib/shake';

/** Whether Shake is running, so its feedback button shows. False on the dev server and in tests. */
export function useShakeReady(): boolean {
    return useSyncExternalStore(subscribeShake, isShakeReady, () => false);
}
